import React from 'react';
import PropTypes from 'prop-types';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/pie';

import _LineBox from './_LineBox';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';
import numeral from 'numeral';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 15 * 1000; //轮询时间间隔

/**
 * * 今日报到人数/总报到人数、报到率饼图、报到统计汇总
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            panelData: {}, //报到统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        if (this.polling) {
            clearTimeout(this.polling);
        }
    }

    /**
     * * 获取报到统计数据
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getStatisticsForReported', 'GET', {campus: '1'})
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, panelData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    if (this.polling) {
                        clearTimeout(this.polling);
                    }
                }
            });
    }

    /**
     * * 构造报到率饼图
     * @memberof Home
     */
    getPieOption = () => {
        const { panelData = {} } = this.state;
        const { rem } = this.props;

        const zbdrs = panelData.zbdrs ? panelData.zbdrs : 0;
        const zrs = panelData.zrs ? panelData.zrs : 0;

        let pieTitleText = '0%';

        if (zrs != 0) {
            let p = zbdrs / zrs * 100;
            if (p == 0 || p == 100) {
                pieTitleText = `${p}%`;
            } else {
                pieTitleText = `${p.toFixed(2)}%`;
            }
        }

        const option = {
            title: {
                text: pieTitleText,
                x: 'center',
                y: 'center',
                textStyle: {
                    fontWeight: 'normal',
                    color: '#00ffca',
                    fontSize: 0.20 * rem
                }
            },
            series: [
                {
                    name: '报到统计',
                    type: 'pie',
                    clockWise: true,
                    radius: ['60%', '75%'],
                    itemStyle: {
                        normal: {
                            label: {
                                show: false
                            },
                            labelLine: {
                                show: false
                            }
                        }
                    },
                    hoverAnimation: false,
                    data: [
                        {
                            name: '报到人数',
                            value: zbdrs,
                            itemStyle: {
                                normal: {
                                    color: '#00ffca',
                                    label: {
                                        show: false
                                    },
                                    labelLine: {
                                        show: false
                                    }
                                }
                            }
                        },
                        {
                            name: '未报到人数',
                            value: zrs - zbdrs,
                            itemStyle: {
                                normal: {
                                    color: '#2659aa'
                                }
                            }
                        }
                    ]
                }
            ]
        };
        return option;
    };

    render() {

        const { panelData } = this.state;
        const { rem } = this.props;

        const zbdrs = panelData.zbdrs ? panelData.zbdrs : 0;
        const zrs = panelData.zrs ? panelData.zrs : 0;

        let pieTitleText = '0%';

        if (zrs != 0) {
            let p = zbdrs / zrs * 100;
            if (p == 0 || p == 100) {
                pieTitleText = `${p}%`;
            } else {
                pieTitleText = `${p.toFixed(2)}%`;
            }
        }

        return (
            <div className={styles.box_2_top_l}>
                <div className={styles.bfb}>
                    <div className={styles.title}>
                        校内今日报到人数{' '}/{' '}校内总报到人数
                                </div>
                    <div className={styles.num} style={{ width: '100%' }}>
                        <span className={styles.color_active}>
                            {panelData.jrbdrs ? panelData.jrbdrs : 0}
                        </span>{' '}
                        /{' '}
                        <span className={styles.color_blue}>
                            {panelData.zbdrs ? panelData.zbdrs : 0}
                        </span>
                    </div>
                    <div className={styles.tip}>
                         较昨天增加 <span className={styles.color_active}>
                             {
                                 panelData.jrbdrs >= panelData.zrbdrs ?
                                     panelData.jrbdrs - panelData.zrbdrs : 0
                             }
                         </span> 人
                     </div>
                </div>
                <div className={styles.pie}>
                    <div className={styles.pie_l}>
                        {/* <ReactEchartsCore
                            style={{ width: '100%', height: '100%' }}
                            echarts={echarts}
                            option={this.getPieOption()}
                            notMerge={true}
                            lazyUpdate={true}
                        /> */}
                        <div className={styles.pie_r_con} style={{left:'50%',transform:'translate(-50%,-50%)'}}>
                        <p style={{fontSize:'20px',color:'#00ffca'}}>{pieTitleText}</p>
                        <p>{panelData.zbdrs}:{panelData.zrs}</p>
                        </div>
                    </div>
                    <div className={styles.pie_r}>
                        <div className={styles.pie_r_con}>
                            <p>校内报到率：{pieTitleText}</p>
                            <p>校内报到人数：{panelData.zbdrs}人</p>
                            <p>校内新生总数：{panelData.zrs}人</p>
                        </div>
                    </div>
                </div>
                <_LineBox rem={rem} />
            </div>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-gdnh/_TopPanelBox.js